<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <!-- 刷新操作区 -->
      <div class="refresh-section">
        <div class="refresh-info">
          <span class="refresh-icon">🔄</span>
          <span>产地价格每6小时自动更新（2:00 / 8:00 / 14:00 / 20:00）</span>
        </div>
        <button class="refresh-btn" @click="refreshPrices" :disabled="loading">
          {{ loading ? '刷新中...' : '立即刷新' }}
        </button>
        <div class="refresh-result" v-if="result">
          <span :class="result.success ? 'success' : 'error'">{{ result.message }}</span>
        </div>
      </div>
      
      <AdminTable 
        :apiEndpoint="'/api/admin/origin-prices'" 
        :columns="config.columns" 
        :filters="config.filters" 
        :formFields="config.formFields" 
        :title="config.title" 
      />
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
import { TABLES_CONFIG } from '@/config/tables'
import axios from 'axios'
import { getAdminPassword } from '../utils/api'

export default {
  name: 'OriginPricesList',
  components: { Sidebar, AdminTable },
  data() {
    return {
      config: TABLES_CONFIG.origin_prices,
      loading: false,
      result: null
    }
  },
  methods: {
    async refreshPrices() {
      this.loading = true
      this.result = null
      try {
        const response = await axios.post('/api/market/crawl-prices', {}, {
          headers: { 'x-admin-password': getAdminPassword() },
          timeout: 180000  // 180秒超时，爬虫需要约2分钟
        })
        if (response.data.code === 200) {
          const { marketCount, originCount } = response.data.data
          this.result = {
            success: true,
            message: `刷新成功！获取 ${marketCount + originCount} 条数据`
          }
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          this.result = { success: false, message: response.data.msg || '刷新失败' }
        }
      } catch (err) {
        console.error('刷新价格失败:', err)
        this.result = { success: false, message: err.code === 'ECONNABORTED' ? '请求超时，请稍后刷新页面查看结果' : '网络错误' }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
.refresh-section { background: white; border-radius: 10px; padding: 16px 20px; margin-bottom: 20px; display: flex; align-items: center; gap: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.refresh-info { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #666; }
.refresh-icon { font-size: 18px; }
.refresh-btn { background: linear-gradient(135deg, #f59e0b, #d97706); color: white; border: none; padding: 10px 20px; border-radius: 6px; font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.2s; }
.refresh-btn:hover:not(:disabled) { transform: translateY(-1px); }
.refresh-btn:disabled { background: #9ca3af; cursor: not-allowed; }
.refresh-result { font-size: 13px; }
.refresh-result .success { color: #10b981; }
.refresh-result .error { color: #ef4444; }
</style>